/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconHash = createReactComponent("hash", "IconHash", [
  ["path", { d: "M5 9l14 0", key: "svg-0" }],
  ["path", { d: "M5 15l14 0", key: "svg-1" }],
  ["path", { d: "M11 4l-4 16", key: "svg-2" }],
  ["path", { d: "M17 4l-4 16", key: "svg-3" }]
]);

export { IconHash as default };
//# sourceMappingURL=IconHash.js.map
